// src/services/api.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://routeoptimizationtestapi.ethicsgroup.in';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// User API
export const getUsers = () => api.get('/api/User');
export const getUserById = (id) => api.get(`/api/User/${id}`);
export const createUser = (user) => api.post('/api/User', user);
export const updateUser = (id, user) => api.put(`/api/User/${id}`, user);
export const deleteUser = (id) => api.delete(`/api/User/${id}`);

// Role API
export const getRoles = () => api.get('/api/Role');
export const getRoleById = (id) => api.get(`/api/Role/${id}`);
export const createRole = (role) => api.post('/api/Role', role);
export const updateRole = (id, role) => api.put(`/api/Role/${id}`, role);
export const deleteRole = (id) => api.delete(`/api/Role/${id}`);
